import { render } from "./Column202502.vue?vue&type=template&id=04793217&scoped=true"
import script from "./Column202502.vue?vue&type=script&lang=js"
export * from "./Column202502.vue?vue&type=script&lang=js"

import "./Column202502.vue?vue&type=style&index=0&id=04793217&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04793217"

export default script